var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"action-button",attrs:{"href":"javascript:;"}},[_c('i',{class:`${_vm.icon}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }